// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__Qgp2f","checkmark":"checkbox_checkmark__zJI4B","checkmarkIndicator":"checkbox_checkmarkIndicator__kHkw_"};